import React, { useState } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { array, bool } from 'prop-types';
import { types as sdkTypes } from '../../util/sdkLoader';
import { useDispatch } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatMoney } from '../../util/currency';
import { DISPLAY_CURRENCY } from '../../util/constants/listing';
import { removeCartItem } from '../../containers/CartPage/CartPage.duck';
import { defaultConfig } from '../../index';

import { LISTING } from '../../util/fetchData';
import { createSlug } from '../../util/urlHelpers';
import { IconSpinner, ResponsiveImage } from '../index';

import NamedLink from '../NamedLink/NamedLink';

import css from './CartInfoPanel.module.css';

const { Money } = sdkTypes;

const TableRow = ({ cartItem, isHideRemoveButton, layout }) => {
    const intl = useIntl();
    const location = useLocation();
    const [isRemovingItem, setIsRemovingItem] = useState(false);
    const dispatch = useDispatch();
    const variantPrefix = 'default';
    const isCheckout = layout === 'checkout';

    const generateDisPlayPrice = (price) => {
        return formatMoney(
            intl,
            new Money(price.amount, price.currency),
            DISPLAY_CURRENCY
        );
    }

    const defaultMoney = {
        amount: 0,
        currency: defaultConfig.currency,
    };
    const {
        title,
        price: youPayPrice = defaultMoney,
    } = LISTING(cartItem).getAttributes();

    const {
        originalPrice = youPayPrice,
    } = LISTING(cartItem).getPublicData();
    const id = LISTING(cartItem).getId();
    const params = { id, slug: createSlug(title) };


    const priceMain = originalPrice
    const { activeSale, date, saleDiscount } = cartItem?.author?.attributes?.profile?.publicData || {}
    const discountedPrice = priceMain?.amount - (priceMain?.amount * parseFloat(saleDiscount) / 100)
    const discountedamount = priceMain?.amount * parseFloat(saleDiscount) / 100

    const discountPrice = {
        amount: activeSale ? -discountedamount : youPayPrice.amount - originalPrice.amount,
        currency: originalPrice.currency,
    };

    const handleClickRemove = () => {
        setIsRemovingItem(true)
        dispatch(removeCartItem(LISTING(cartItem).getId())).then(() => {
            setIsRemovingItem(false)
        })
    }

    const firstImage = cartItem?.images[0];
    const variants = firstImage
        ? Object.keys(firstImage.attributes?.variants).filter(k => k.startsWith(variantPrefix))
        : [];


    // discounted

    return (
        <>
            <div className={classNames(css.itemInfo, { [css.itemInfoCheckout]: isCheckout })} key={`${id}-name`}>
                <div className={classNames(css.imageWrapper, { [css.imageWrapperCheckout]: isCheckout })}>
                    <ResponsiveImage
                        rootClassName={css.rootForImage}
                        alt={title}
                        image={firstImage}
                        variants={variants}
                    />
                </div>
                <NamedLink
                    className={classNames(css.listingTitle, { [css.listingTitleCheckout]: isCheckout })}
                    name="ListingPage"
                    params={params}
                    to={{ search: `from=${location.pathname}${location.search}` }}
                    target="_blank"
                >
                    {title}
                </NamedLink>
            </div>
            <div className={classNames({ [css.priceCheckout]: isCheckout })} key={`${id}-original-price`}>
                {generateDisPlayPrice(activeSale ? new Money(activeSale ? priceMain?.amount : discountedPrice, originalPrice.currency) : originalPrice)}
            </div>
            <div className={classNames({ [css.priceCheckout]: isCheckout })} key={`${id}-discount-price`}>
                {generateDisPlayPrice(discountPrice)}
            </div>
            <div className={classNames(css.payPriceItem, { [css.priceCheckout]: isCheckout })} key={`${id}-pay-price`}>
                {generateDisPlayPrice(activeSale ? new Money(discountedPrice, originalPrice.currency) : youPayPrice)}
            </div>
            {!isHideRemoveButton && (
                <div key={`${id}-remove-button`}>
                    <span
                        className={css.removeFromCartButton}
                        onClick={handleClickRemove}
                    >
                        {isRemovingItem ? (
                            <IconSpinner />
                        ) : (
                            <FormattedMessage id='CartInfoPanel.removeButton' />
                        )}
                    </span>
                </div>
            )}
        </>
    )
}

const CartDesktop = (props) => {
    const {
        className,
        rootClassName,
        listItems,
        isHideRemoveButton,
        layout,
    } = props;
    const intl = useIntl();
    const isCheckout = layout === 'checkout';

    const listTableColumnsTitlesId = [
        "CartInfoPanel.tableColumnItemTitle",
        "CartInfoPanel.tableColumnPriceTitle",
        "CartInfoPanel.tableColumnDiscountTitle",
        "CartInfoPanel.tableColumnPayPriceTitle",
        "", // empty column for remove button
    ];

    if (isHideRemoveButton) {
        listTableColumnsTitlesId.pop();
    }

    const wrapperClasses = classNames(
        rootClassName || css.tableDesktopWrapper,
        isHideRemoveButton ? css.tableDesktopFourColumn : css.tableDesktopFiveColumn,
        { [css.tableDesktopWrapperCheckout]: isCheckout },
        className
    );

    return (
        <div className={wrapperClasses}>
            {listTableColumnsTitlesId.map((titleId) => (
                <div className={classNames(css.tableColumnTitle, { [css.tableColumnTitleCheckout]: isCheckout })} key={titleId}>
                    {titleId && <FormattedMessage id={titleId} />}
                </div>
            ))}
            {listItems.map((item) => <TableRow cartItem={item} isHideRemoveButton={isHideRemoveButton} layout={layout} />)}
        </div>
    );
}

TableRow.propTypes = {
    listItems: array,
    isHideRemoveButton: bool,
}

CartDesktop.defaultProps = {
    listItems: [],
    isHideRemoveButton: false,
}

CartDesktop.propTypes = {
    listItems: array,
    isHideRemoveButton: bool,
}

export default CartDesktop;
